export default __webpack_public_path__ + "static/media/GL.f044a4cf.svg";